"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var cart_1 = require("../../utils/cart");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var ga_1 = require("../../utils/ga");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var CartUpsellSex = function (_a) {
    var _b, _c, _d, _e;
    var replacedItem = _a.replacedItem;
    var _f = (0, hooks_1.useContext)(CartContext_1.default), allProducts = _f.allProducts, cart = _f.cart, renderCart = _f.renderCart;
    var replacedItemInCart = cart.items.find(function (prod) { return prod.title === replacedItem.title; });
    var replacedItemAsProduct = allProducts.find(function (prod) { return prod.title === replacedItem.title; });
    if (!replacedItemAsProduct) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var upsoldItem = allProducts.find(function (prod) { var _a; return (0, cart_1.isSubscriptionItem)(prod) && ((_a = prod.replace) === null || _a === void 0 ? void 0 : _a.value) === replacedItemAsProduct.handle; });
    if (!upsoldItem) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var handleCtaClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    event.preventDefault();
                    return [4 /*yield*/, (0, cart_1.updateCart)(event, replacedItemInCart)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, renderCart()];
                case 2:
                    _a.sent();
                    (0, ga_1.sendEventAddToCart)(upsoldItem, upsoldItem.variants.nodes[0], ga_1.GaMethodValue.cartUpsell);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, preact_1.h)(preact_1.Fragment, null,
        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item" },
            (0, preact_1.h)("img", { class: "cart-section__you-may-also-like-item-image", src: (_b = upsoldItem.featuredImage) === null || _b === void 0 ? void 0 : _b.src }),
            (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info" },
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info-product" },
                    ((_c = upsoldItem.upsellStatus) === null || _c === void 0 ? void 0 : _c.value) && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-badge" }, upsoldItem.upsellStatus.value)),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("h4", { class: "cart-section__you-may-also-like-item-header" }, upsoldItem.title)),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-benefit" },
                            (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/checkmark-orange.svg?v=1694457685", alt: "checkmark" }),
                            (0, preact_1.h)("p", null,
                                "3 Bottles Delivered ",
                                (0, preact_1.h)("br", { class: "hide-on-desktop" }),
                                "Every Month")),
                        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-benefit" },
                            (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/checkmark-orange.svg?v=1694457685", alt: "checkmark" }),
                            ' ',
                            (0, preact_1.h)("p", null, "Free Shipping Always")),
                        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-benefit" },
                            (0, preact_1.h)("img", { src: "https://cdn.shopify.com/s/files/1/0588/9340/2261/files/checkmark-orange.svg?v=1694457685", alt: "checkmark" }),
                            ' ',
                            (0, preact_1.h)("p", null, "Cancel Anytime")))),
                (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price-cta" },
                    (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price" },
                        upsoldItem.variants.nodes[0].compareAtPrice && ((0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-price--strikethrough" }, (0, hydrogen_react_1.useMoney)({
                            amount: String(Math.ceil(+upsoldItem.variants.nodes[0].compareAtPrice.amount)),
                            currencyCode: 'USD',
                        }).withoutTrailingZeros)),
                        "\u00A0",
                        (0, hydrogen_react_1.useMoney)(upsoldItem.variants.nodes[0].price).withoutTrailingZeros,
                        "/mo"),
                    (0, preact_1.h)("div", null,
                        (0, preact_1.h)("form", { method: "POST", action: "/cart/add", class: "trigger--cart trigger--replace", "data-replace-item": replacedItemInCart === null || replacedItemInCart === void 0 ? void 0 : replacedItemInCart.id, onSubmit: function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, handleCtaClick(event)];
                                    case 1: return [2 /*return*/, _a.sent()];
                                }
                            }); }); } },
                            (0, preact_1.h)("input", { type: "hidden", name: "quantity", value: "1" }),
                            (0, preact_1.h)("input", { type: "hidden", name: "id", value: Number(upsoldItem.variants.nodes[0].id.split('/')[4]) }),
                            (0, preact_1.h)("input", { type: "hidden", name: "selling_plan", value: Number((_e = (_d = upsoldItem.sellingPlanGroups.nodes[0]) === null || _d === void 0 ? void 0 : _d.sellingPlans.nodes[0]) === null || _e === void 0 ? void 0 : _e.id.split('/')[4]) }),
                            (0, preact_1.h)("button", { type: "submit", class: "cart-section__you-may-also-like-item-cta" }, "Apply Offer"))))))));
};
exports.default = CartUpsellSex;
